import { Injectable } from "@angular/core";
import { combineLatest, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { Package } from "src/app/shared/types/contract-types";

@Injectable({
  providedIn: "root",
})
export class TierManagmentService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/DefaultPackages/${endpoint}`;
  }

  getTiers(): Observable<Package[]> {
    return this.http.get<Package[]>(this.apiUrlWithEndpoint(""));
  }

  updateTier(tier: Package): Observable<Package> {
    return this.http.put<Package>(this.apiUrlWithEndpoint(`${tier.id}`), tier);
  }

  getTierById(id: number): Observable<Package> {
    return this.http.get<Package>(this.apiUrlWithEndpoint(`${id}`));
  }

  updateTiers(tiers: Package[]): Observable<Package[]> {
    const updateRequests = tiers.map(tier => this.updateTier(tier));
    return combineLatest(updateRequests);
  }
}
